import React, { useState } from 'react';
import { Divider, Grid, Typography } from '@mui/material';

import CustomTooltip from '@shared/components/Tooltip';

const TAXES_TOOLTIP_ID = 'taxesTooltip';

const TaxesTooltip = ({
  tax_detail,
  formatValue,
  disableHover = false,
  children,
}) => {
  const [taxesTooltip, setTaxesTooltip] = useState(null);

  return (
    <Grid
      onMouseEnter={() => !disableHover && setTaxesTooltip(TAXES_TOOLTIP_ID)}
      onMouseLeave={() => !disableHover && setTaxesTooltip(null)}
      style={{ position: 'relative' }}
    >
      {children}

      <CustomTooltip
        anchor={taxesTooltip}
        elementId={TAXES_TOOLTIP_ID}
        stylesProp={{ top: '30px', maxWidth: '220px', padding: '8px 16px' }}
      >
        <Grid>
          <Typography
            sx={{ fontWeight: 600, textAlign: 'center' }}
            style={{ fontSize: '16px', whiteSpace: 'nowrap' }}
          >
            Impuestos Aéreos
          </Typography>

          <Divider style={{ margin: '5px 0' }} />

          {Object.keys(tax_detail || {}).length > 0 ? (
            Object.keys(tax_detail).map((x, i) => (
              <Typography
                key={`tax-detail-${x}-${+i}`}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '10px',
                  whiteSpace: 'nowrap',
                }}
              >
                <Typography
                  component="span"
                  sx={{ pl: '1px', fontSize: '14px' }}
                >
                  {x}:
                </Typography>
                <Typography
                  component="span"
                  sx={{
                    wordBreak: 'break-word',
                    pr: '1px',
                    pl: '1px',
                    whiteSpace: 'nowrap',
                    fontSize: '14px',
                  }}
                >
                  {formatValue(tax_detail[x])}
                </Typography>
              </Typography>
            ))
          ) : (
            <Typography style={{ fontSize: '0.9rem' }}>
              No hay detalles de impuestos
            </Typography>
          )}
        </Grid>
      </CustomTooltip>
    </Grid>
  );
};

export default TaxesTooltip;
